/**
 * Csv Schema of ParametroRelatorio
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ParametroRelatorio} from '@/model/resource/ParametroRelatorio'

/* TODO: review generated schema */
export class CsvParametroRelatorioSchema extends Schema {
  readonly name = 'CsvParametroRelatorio'

  readonly fieldSet: FieldSet<ParametroRelatorio> = {
    idParametroRelatorioPk: schema => schema.model.idParametroRelatorioPk,
    relatorioGeracao: schema => schema.model.relatorioGeracao?.$id ?? null,
    dateBy: schema => schema.model.dateBy,
    cnpjDestinatario: schema => schema.model.cnpjDestinatario,
    cnpjEmbarcadorTransportador: schema =>
      schema.model.cnpjEmbarcadorTransportador,
    nroFiscal: schema => schema.model.nroFiscal,
    ocorrencia: schema => schema.model.ocorrencia,
    auditoria: schema => schema.model.auditoria,
    comMotorista: schema => schema.model.comMotorista,
    idMotorista: schema => schema.model.idMotorista,
    idStatus: schema => schema.model.idStatus,
    slaPendente: schema => schema.model.slaPendente,
    cep: schema => schema.model.cep,
    uf: schema => schema.model.uf,
    cidade: schema => schema.model.cidade,
    cte: schema => schema.model.cte,
    idOcorrencia: schema => schema.model.idOcorrencia,
    start: schema => Helper.datetime(schema.model.start),
    end: schema => Helper.datetime(schema.model.end),
  }
}
